module.exports = __webpack_public_path__ + "static/media/img-9.png";